import { DemandDraftDetail } from '~/api/demands/_types';

export const useDemandDraftDetailStore = defineStore('demand-draft', () => {
    const activeDemandDraft = ref<DemandDraftDetail | null>(null);

    const reset = () => {
        activeDemandDraft.value = null;
    };

    return {
        activeDemandDraft,
        reset,
    };
});
